/**
 * Function to copy text to clipboard
 */
export default function ts_init_copy_to_clipboard() {
    // Select all elements with the data-clipboard attribute
    const targets = document.querySelectorAll('[data-clipboard]');

    // Loop through each element
    targets.forEach(function (target) {
        let parent = target.parentElement;
        parent.classList.remove('animate__flash', 'animate__animated');

        // Copy to clipboard using the clipboard API
        target.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            navigator.clipboard.writeText(target.dataset.clipboard).then(function () {
                console.log('Text copied to clipboard');
                parent.classList.add('animate__flash', 'animate__animated');

                setTimeout(function () {
                    parent.classList.remove('animate__flash', 'animate__animated');
                }, 2000);

            }, function (err) {
                console.error('Failed to copy text', err);
            });
        });
    });
}
